// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Term deposits'"></sub-header>
  <div>
    <a class="pull-right btn btn-primary"
       command-access="CreateDepositType"
       ng-href="#!/admin/term-deposits/types/create">
      Create new
    </a>
    <dynamic-list
      columns="\$ctrl.columns"
      data="\$ctrl.termDeposits"
      sorting="\$ctrl.sorting">
    </dynamic-list>

    <div ng-if="!\$ctrl.termDeposits || !\$ctrl.termDeposits.length" class="empty-message">
      <span>No term deposits found.</span>
    </div>

    <div class="buttons">
      <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Back</button>
    </div>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/term-deposit/list/term-deposit-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;